// extracted by mini-css-extract-plugin
module.exports = {"flag":"et_eu"};